import { api } from "@/APIRequests";

export async function getUnreadMessageCount(): Promise<number> {
  const response = await api.messagingTyped.fetch_unread_message_count();

  return response.unread_count;
}
